import { Grid, Typography, TypographyProps } from '@mui/material';
import _ from 'lodash';
import React from 'react';

interface AmountProps extends TypographyProps {
    amount: number;
}

const Amount: React.FC<AmountProps> = (props) => {
    const { amount } = props;

    var deepClonedAmount = _.cloneDeep(amount);
    var fixedAmount = deepClonedAmount.toFixed(2);
    var formattedAmount = fixedAmount.replace('.', ',')

    return (
        <Grid container wrap='nowrap' width={"auto"}>
            <Typography {...props}>{formattedAmount}</Typography>
            <Typography {...props} ml={0.4}>KM</Typography>
        </Grid>
    )
}

export default Amount;